import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { Fragment } from 'react';
import memoizeOne from 'memoize-one';
import { getNodeRenderer } from '@atlaskit/editor-common/extensions';
import { WithProviders } from '@atlaskit/editor-common/provider-factory';
import { getExtensionRenderer } from '@atlaskit/editor-common/utils';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
var inlineExtensionStyle = css({
  display: 'inline-block',
  maxWidth: '100%',
  verticalAlign: 'middle',
  // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  margin: "1px 1px ".concat("var(--ds-space-050, 4px)"),
  '& .rich-media-item': {
    maxWidth: '100%'
  }
});
var ExtensionRenderer = /*#__PURE__*/function (_React$Component) {
  _inherits(ExtensionRenderer, _React$Component);
  var _super = _createSuper(ExtensionRenderer);
  function ExtensionRenderer() {
    var _this;
    _classCallCheck(this, ExtensionRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      extensionProvider: null
    });
    _defineProperty(_assertThisInitialized(_this), "mounted", false);
    _defineProperty(_assertThisInitialized(_this), "handleProvider", function (name, providerPromise) {
      providerPromise && providerPromise.then(function (provider) {
        if (_this.mounted) {
          _this.setState(_defineProperty({}, name, provider));
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getNodeRenderer", memoizeOne(getNodeRenderer));
    _defineProperty(_assertThisInitialized(_this), "renderExtensionNode", function (extensionProvider) {
      var _marks$find;
      var _this$props = _this.props,
        extensionHandlers = _this$props.extensionHandlers,
        rendererContext = _this$props.rendererContext,
        extensionType = _this$props.extensionType,
        extensionKey = _this$props.extensionKey,
        parameters = _this$props.parameters,
        content = _this$props.content,
        text = _this$props.text,
        type = _this$props.type,
        localId = _this$props.localId,
        marks = _this$props.marks,
        actions = _this$props.actions;
      var fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find(function (m) {
        return m.type.name === 'fragment';
      })) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
      var node = {
        type: type,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: parameters,
        content: content || text,
        localId: localId,
        fragmentLocalId: fragmentLocalId
      };
      var result = null;
      try {
        if (extensionHandlers && extensionHandlers[extensionType]) {
          var render = getExtensionRenderer(extensionHandlers[extensionType]);
          result = render(node, rendererContext.adDoc);
        }
        if (!result && extensionProvider) {
          var NodeRenderer = _this.getNodeRenderer(extensionProvider, extensionType, extensionKey);
          if (node.type === 'multiBodiedExtension') {
            result = jsx(NodeRenderer, {
              node: node,
              actions: actions
            });
          } else if (node.type === 'inlineExtension') {
            result = jsx(InlineNodeRendererWrapper, null, jsx(NodeRenderer, {
              node: node
            }));
          } else {
            result = jsx(NodeRenderer, {
              node: node
            });
          }
        }
      } catch (e) {
        /** We don't want this error to block renderer */
        /** We keep rendering the default content */
      }
      return _this.props.children({
        result: result
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setupAndRenderExtensionNode", function (providers) {
      var extensionProvider = _this.state.extensionProvider;
      if (!extensionProvider && providers.extensionProvider) {
        _this.handleProvider('extensionProvider', providers.extensionProvider);
      }
      return _this.renderExtensionNode(extensionProvider);
    });
    return _this;
  }
  _createClass(ExtensionRenderer, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var providers = this.props.providers;
      if (!providers) {
        return this.setupAndRenderExtensionNode({});
      }
      return jsx(WithProviders, {
        providers: ['extensionProvider'],
        providerFactory: providers,
        renderNode: this.setupAndRenderExtensionNode
      });
    }
  }]);
  return ExtensionRenderer;
}(React.Component);
export { ExtensionRenderer as default };
var InlineNodeRendererWrapper = function InlineNodeRendererWrapper(_ref) {
  var children = _ref.children;
  if (getBooleanFF('platform.editor.inline_extension.extended_lcqdn')) {
    return jsx("div", {
      className: "inline-extension-renderer",
      css: inlineExtensionStyle
    }, children);
  }
  return jsx(Fragment, null, children);
};